
<div class="preview-modal-background">
    <div class="preview-modal-header">
        <div class="preview-modal-button-close" (click)="closeModal()">
            <i class="icon-smash_close"></i>
        </div>
        <div class="paginator">{{ selectedFile.index + 1 }} / {{ preview.transfer.filesNumber }}</div>
    </div>
    <div class="preview-modal-content" *ngIf="files.length">
        <app-smash-swiper swiperContainerId="preview-swiper" 
                (indexChanged)="onIndexChange($event)" 
                [(index)]="selectedFile.index"
                [items]="files"
                (reachedEnd)="onReachEnd()">              
            <swiper-slide #smashSwiperSlide *ngFor="let item of files" >
                <!-- Image -->
                <ng-container *ngIf="previewable && item.type === 'image'">
                    <div class="swiper-image">            
                        <app-smash-image class="thumbnail" [url]="item.preview" type="preview" (imageLoadError)="handleImageError()" [device]="device"></app-smash-image>
                    </div>
                </ng-container>
                <!-- Video -->
                <ng-container *ngIf="previewable && item.type === 'video' && selectedFile.index === item.index && !!playerSource && !!playerOptions">
                    <div class="video-container">
                        <app-smash-player 
                        [source]="playerSource" 
                        [options]="playerOptions" 
                        (plyrEnterFullScreen)="lockNavigation()"                    
                        (plyrExitFullScreen)="unlockNavigation()"></app-smash-player>
                    </div>
                </ng-container>
                <!-- Audio -->
                <ng-container *ngIf="previewable && item.type === 'audio' && selectedFile.index === item.index">
                    <div class="audio-wrapper-container">
                        <app-file-extension [fileType]="item.type" [fileExtension]="item.ext" [device]="device"/>
                        <div class="sound-player-wrapper-slider" >
                            <div [ngClass]="{'icon-smash_player': !playerIsPlaying, 'icon-smash_pause': !!playerIsPlaying}" (click)="togglePlay($event)">
                            </div>
                            <app-smash-player #player 
                            [source]="playerSource" 
                            [options]="playerOptions"
                            class="smash-sound-player"></app-smash-player>
                        </div>
                    </div>
                </ng-container>
                <!-- Not previewable -->
                <ng-container *ngIf="!previewable">
                    <div class="not-previewable-container">
                        <!-- Unknown File Type -->
                        <app-file-extension [fileType]="item.type" [fileExtension]="item.ext" [device]="device"/>
                        <div>
                            <div class="text-1">
                                {{ 'VIEWER_PREVIEW_NOT_AVAILABLE' | translate }}
                            </div>
                            <div class="text-2">
                                {{ 'VIEWER_FILE_AVAILABLE_LEARN_MORE_1' | translate }} <a target="_blank"
                                    href="{{ 'VIEWER_FILE_AVAILABLE_LEARN_MORE_LINK' | translate }}">{{ 'VIEWER_FILE_AVAILABLE_LEARN_MORE_LINK_TEXT' |
                                    translate
                                    }}</a>
                                {{ 'VIEWER_FILE_AVAILABLE_LEARN_MORE_2' | translate }}
                            </div>
                        </div>
                    </div>
                </ng-container>
            </swiper-slide>
        </app-smash-swiper>
    </div>
    <app-smash-snackbar class="swiper-snackbar">
        <div class="swiper-snackbar-content">
            <div *ngIf="device.isDesktop" class="swiper-snackbar-content-left">
                <div class="file-name">{{selectedFile.name}}</div>
                <div class="file-size">({{selectedFile.size | bytes:2}})</div>
            </div>
            <div class="swiper-snackbar-content-right">
                <button *ngIf="device.isDesktop" class="btn-v3 large primary" (click)="downloadFile(selectedFile)">
                    {{ 'VIEWER_DOWNLOAD' | translate }}
                </button>
                <div *ngIf="device.isTablet" class="file-download-container" (click)="$event.stopPropagation()">
                    <a [href]="selectedFile.download" target="_blank" class="btn-v3 large primary" (click)="$event.stopPropagation()">
                        {{ 'VIEWER_DOWNLOAD' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </app-smash-snackbar>
</div>

